var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21953 10.9156L7.90953 7.48991C8.03036 7.37767 8.03016 7.19595 7.90891 7.0839C7.78767 6.97193 7.59128 6.97222 7.47036 7.08448L3.99999 10.3063L0.529624 7.08436C0.408687 6.97212 0.212421 6.97183 0.0911717 7.08378C0.0303907 7.13995 0 7.21354 0 7.28713C0 7.36052 0.0301876 7.43382 0.0905466 7.48989L3.78046 10.9156C3.83855 10.9697 3.91761 11 3.99999 11C4.08236 11 4.16133 10.9696 4.21953 10.9156Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78047 0.0843928L0.0904667 3.51009C-0.0303609 3.62233 -0.0301578 3.80405 0.0910917 3.9161C0.212326 4.02807 0.408716 4.02778 0.529637 3.91552L4.00001 0.69373L7.47038 3.91564C7.59131 4.02788 7.78758 4.02817 7.90883 3.91622C7.96961 3.86005 8 3.78646 8 3.71287C8 3.63948 7.96981 3.56618 7.90945 3.51011L4.21954 0.0843928C4.16145 0.0303347 4.08239 0 4.00001 0C3.91764 0 3.83867 0.0304215 3.78047 0.0843928Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLink);
export default __webpack_public_path__ + "static/media/tableLink.78562717f35dcefa3376bb73a3534656.svg";
export { ForwardRef as ReactComponent };